export default function () {
  const widgetName = 'faircards';
  const widgetOpts = faircardsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (slide) {

      function customStyle() {
        $(`#${widgetName} .card-widget-item`).each(function () {
          // $(this).removeAttr('target');
          // $(this).find('.buttonwrap').remove();
          $(this).find('.image-container').append('<div class="overlay"></div>');
          $(this).find('.moreButton').addClass('button');
          $(this).find('.button').removeClass('moreButton');
          $(this).find('.button').removeAttr('target');
          $(`#${widgetName}`).appendTo('.tier-two')
        
        })
      }
      customStyle()

    },
    buyNowButton: {
      visible: false,
      text: 'BUY NOW!'
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 8,
    moreButton: {
      visible: true,
      text: 'More'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true
  });
}